import { Modal } from "@telegram-apps/telegram-ui";
import "./CurrenciesModal.css";
import { TUIModalHeader } from "../TUIModalHeader/TUIModalHeader";
import { useI18n } from "../../utils/i18n/I18nProvider";

interface CurrenciesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CurrenciesModal({ isOpen, onClose }: CurrenciesModalProps) {
  const { t } = useI18n();

  return (
    <Modal
      open={isOpen}
      header={<TUIModalHeader />}
      onOpenChange={(open) => !open && onClose()}
      className="currencies-modal"
    >
      <div className="currencies-modal__content">
        {/* Header */}
        <div className="currencies-modal__header">
          <h2 className="currencies-modal__title">
            {t("currenciesModal.title")}
          </h2>
        </div>
        <div className="currencies-modal__currencies-list">
          {/* Coins */}
          <div className="currencies-modal__currency-item">
            <img
              src="/assets/img/ui/coin.webp"
              alt={t("currenciesModal.currencies.coins.name")}
              className="currencies-modal__currency-icon"
            />
            <div className="currencies-modal__currency-info">
              <h3 className="currencies-modal__currency-name">
                {t("currenciesModal.currencies.coins.name")}
              </h3>
              <p className="currencies-modal__currency-description">
                {t("currenciesModal.currencies.coins.description")}
              </p>
            </div>
          </div>

          {/* MANA */}
          <div className="currencies-modal__currency-item">
            <img
              src="/assets/img/ui/mana.webp"
              alt={t("currenciesModal.currencies.mana.name")}
              className="currencies-modal__currency-icon"
            />
            <div className="currencies-modal__currency-info">
              <h3 className="currencies-modal__currency-name">
                {t("currenciesModal.currencies.mana.name")}
              </h3>
              <p className="currencies-modal__currency-description">
                {t("currenciesModal.currencies.mana.description")}
              </p>
            </div>
          </div>

          {/* $EVL */}
          <div className="currencies-modal__currency-item">
            <img
              src="/assets/img/ui/EVL.webp"
              alt={t("currenciesModal.currencies.evl.name")}
              className="currencies-modal__currency-icon"
            />
            <div className="currencies-modal__currency-info">
              <h3 className="currencies-modal__currency-name">
                {t("currenciesModal.currencies.evl.name")}
              </h3>
              <p className="currencies-modal__currency-description">
                {t("currenciesModal.currencies.evl.description")}
              </p>
            </div>
          </div>

          {/* USDT */}
          <div className="currencies-modal__currency-item">
            <img
              src="/assets/img/ui/USDT.webp"
              alt={t("currenciesModal.currencies.usdt.name")}
              className="currencies-modal__currency-icon"
            />
            <div className="currencies-modal__currency-info">
              <h3 className="currencies-modal__currency-name">
                {t("currenciesModal.currencies.usdt.name")}
              </h3>
              <p className="currencies-modal__currency-description">
                {t("currenciesModal.currencies.usdt.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
